import Cookies from 'js-cookie'
import store from '../store'

const TokenKey = 'XXH-SSO-TOKEN'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getCookie(key) {
  return Cookies.get(key)
}

// 根据指定菜单code 获取是否存在拉拉
export function getQueryMenuCodeView(code) {
  return new Promise(function(resolve, reject){
    // 具备德招聘权限
    store.dispatch('app/queryMenuList').then(() => {
      let isOk = false
      let list = store.state.app.menuList
      function yanzheng(code, list) {
        list.forEach(vb => {
          if(vb.code === code) {
            isOk = true
          }
          if(vb && vb.children) {
            yanzheng(code, vb.children)
          }
        });
      }
      yanzheng(code, list)
      resolve(isOk)
      
    })
  })


}

export function setCookie(key, token) {
  // if (process.env.NODE_ENV === 'uat') {
  //   return Cookies.set(key, token, { domain: '.71360.com' })
  // }
  // .dhrforce.com
  return Cookies.set(key, token, { domain: '.dhrforce.com' })
}
